<template>
  <b-row>
    <b-col cols="12">
      <overview-instagram :mainData="data.main_child.detail" @updateProfile="updateProfile"/>
    </b-col>

    <b-col cols="12" v-if="data.main_child.detail.brand_safety">
      <brand-safety :brand_safety="data.main_child.detail.brand_safety"/>
    </b-col>

    <b-col cols="12">
      <main-instagram :mainData="data.main_child.detail" />
    </b-col>

    <b-col cols="12" v-if="role !== 'espejo'">
      <price-estimated :data="data.main_child.detail" />
    </b-col>

    <!-- Country City -->
    <b-col cols="12">
      <country-city-graph v-if="audienceData.gender_age.length > 0" :audienceData="audienceData"></country-city-graph>
    </b-col>

    <!-- audience graph -->
    <b-col cols="12">
      <audience-graph :audienceData="audienceData"/>
    </b-col>

    <!-- interest -->
    <b-col cols="12">
      <b-row class="px-1">
        <interest-instagram v-if="audienceData.interests.length > 0" :audienceData="audienceData"></interest-instagram>
      </b-row>
    </b-col>

    <!-- gender graph -->
    <b-col cols="12">
      <gender-age-graph v-if="checkAgeGender()" :graphData="audienceData" :type="true"></gender-age-graph>
    </b-col>

    <!-- load more  -->
    <b-col cols="12">
      <profile-crecimiento :audienceData="audienceData" />
    </b-col>

    <b-col cols="12" v-if="showEmbedInstagram && media.length > 0">
      <instagram-media :contents="media" :media_ids="media_ids" :avatar="getAvatar()"/>
    </b-col>

  </b-row>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import profile_services from '@/services/profile'
export default {
  components: {
    BRow,
    BCol,
    OverviewInstagram: () => import('./OverviewInstagram.vue'),
    MainInstagram: () => import('./MainInstagram.vue'),
    InterestInstagram: () => import('./InterestInstagram.vue'),
    PriceEstimated: () => import('../priceEstimated.vue'),
    CountryCityGraph: () => import('./CountryCityGraph.vue'),
    AudienceGraph: () => import('../AudienceGraph.vue'),
    GenderAgeGraph: () => import('../GenderAgeGraph.vue'),
    ProfileCrecimiento: () => import('../ProfileCrecimiento.vue'),
    BrandSafety: () => import('./BrandSafety.vue'),
    InstagramMedia: () => import('./InstagramMedia.vue')
  },
  props: {
    data: {
      Type: Object,
      required: true
    },
    headerData: {
      Type: Object,
      required: true
    },
    showEmbedInstagram: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      role: 'brand',
      media: [],
      media_ids: {}
    }
  },
  created() {
    const userData = JSON.parse(localStorage.getItem('userData'))
    this.role = userData.groups[0].name
    this.getMedia()
  },
  computed: {
    audienceData() {
      const audienceData = []
      audienceData.followersTotal = this.data.calculate_followers.total
      audienceData.cities = this.data.main_child?.detail?.audience_geography?.cities ?? []
      audienceData.countries = this.data?.main_child?.detail?.audience_geography?.countries ?? []
      audienceData.authenticity = this.data.main_child.detail.audience_authenticity
      audienceData.type = this.data.main_child.detail.audience_type
      audienceData.gender_age = this.data.main_child.detail.demography_by_age ?? []
      audienceData.ethnicity = this.data.main_child.detail.audience_ethnicity
      audienceData.languages = this.data.main_child.detail.audience_languages
      audienceData.reachability = this.data.main_child.detail.audience_reachability
      audienceData.interests = this.data.main_child.detail.audience_interests ?? []
      audienceData.growth = this.data.main_child.detail.growth
      audienceData.followers_chart = this.data.main_child.detail.followers_chart
      audienceData.following_chart = this.data.main_child.detail.following_chart
      audienceData.comments_rate = this.data.main_child.detail.comments_rate
      audienceData.comments_authenticity = this.data.main_child.detail.comments_authenticity
      audienceData.likes_comments_ratio = this.data.main_child.detail.likes_comments_ratio
      audienceData.estimation = this.data.main_child.detail.estimation
      return audienceData
    }
  },
  methods: {
    updateProfile() {
      this.$emit('updateProfile');
    },

    getAvatar() {
      return this.headerData.avatar
    },
    getMedia() {
      profile_services.getMedia(this.$route.params.alias ? this.$route.params.alias : this.$route.params.username, 'instagram')
        .then(response => {
          const media = response.media || {};
          const contents = Object.values(media);

          const contents_format = contents.map(content => ({
            ...content,
            id: content.basic?.id,
            username: this.headerData.username,
            network: this.headerData.main.network,
            followers: 0,
            avatar: this.headerData.avatar,
            is_verified: this.headerData.is_verified
          }));

          this.media = contents_format;
          this.media_ids = response.media_ids || {};
        });
    },
    checkAgeGender() {
      if (this.audienceData.countries && this.audienceData.countries.length > 0) {
        return true
      } else if (this.audienceData.cities && this.audienceData.cities.length > 0) {
        return true
      }

      return false
    }
  }
}
</script>
